import React, { FC } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Button } from '@components/Button'
import { ChevronLeftIcon } from '@components/Icons'
import {
  TabWrapper,
  IconWrapper,
  getBtnStyles,
} from './Tab.elements'

type Props = {
  title: string
  isActive: boolean
  onActivate: () => void
  tabPanelId: string
}

export const Tab: FC<Props> = ({ title, isActive, tabPanelId, onActivate }) => {
  return (
    <TabWrapper>
      <Button
        variant={isActive ? 'default' : 'text'}
        onClick={onActivate}
        css={getBtnStyles(isActive)}
        role="tab"
        aria-selected={isActive}
        aria-controls={tabPanelId}
      >
        {title}
        <IconWrapper>
          <ChevronLeftIcon />
        </IconWrapper>
      </Button>
    </TabWrapper>
  )
}
